import Button from 'components/button';
import { INE_URL } from 'constants/domains';
import {
  getOriginalAccessToken,
  removeOriginalAccessToken,
  setAccessToken,
} from '@internetworkexpert/js-common';
import { useState } from 'react';
import styled from 'styled-components';

const Container = styled.main`
  align-items: center;
  color: #1a2535;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  margin: 0 auto;
  max-width: 640px;
  padding: 24px;
  text-align: center;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
`;

const DomainAccessError = (): JSX.Element => {
  const [isRecovering, setIsRecovering] = useState(false);
  const isImpersonating = Boolean(getOriginalAccessToken());

  const stopImpersonating = () => {
    const originalAccessToken = getOriginalAccessToken();
    if (!originalAccessToken || isRecovering) return;

    setIsRecovering(true);
    setAccessToken(originalAccessToken);
    removeOriginalAccessToken();
    window.location.reload();
  };

  return (
    <Container>
      <h1>Your email domain is not allowed for this account.</h1>
      <p>
        Please ask your account administrator to add your email domain to the account, then try
        again.
      </p>
      <Actions>
        {isImpersonating && (
          <Button $secondary disabled={isRecovering} onClick={stopImpersonating}>
            Stop impersonating
          </Button>
        )}
        <Button href={INE_URL || '/'}>Return to INE</Button>
      </Actions>
    </Container>
  );
};

export default DomainAccessError;
